import { useEffect } from 'react'

interface useInitAuditLogProps {
  getRows: Function
  setRows: Function
  setShowOverlay: Function
}

const useInit = (props: useInitAuditLogProps) => {
  useEffect(() => {
    props.getRows().then((data: any) => {
      props.setRows(data)
      props.setShowOverlay(false)
    })
  }, [])
}

export default useInit
